const SpinnerLoader = () => {
  return (
    <div className="relative bg-white dark:bg-gray-900 dark:bg-opacity-90 p-2 rounded-lg mb-6 overflow-hidden transition-colors duration-300">
      <div className="flex items-center justify-center h-40">
        <div className="spinner-container">
          <div
            className="w-16 h-16 border-transparent border-b-gray-100 border-l-gray-100 border-r-gray-100 border-t-primary-400 rounded-full animate-spin box-border block"
            style={{
              borderWidth: "6px",
            }}
          />
          <style>{`
            @keyframes spin {
              0% {
                transform: rotate(0deg);
              }
              100% {
                transform: rotate(360deg);
              }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
};

export default SpinnerLoader;
